import React, { memo, useMemo } from "react";
import { BaseballTable } from "../tables/BaseballTable";
import { getTeamBattingColumns } from "../../config/teamBattingColumns";
import { getTeamPitchingColumns } from "../../config/teamPitchingColumns";
import { Roster } from "./Roster";
import { TeamGames } from "./TeamGames";
import { PitcherUtilization } from "./PitcherUtilization";
import { LineupUsage } from "./LineupUsage";
import { TeamStatTable } from "./TeamStatTable";
import { STAT_TYPES } from "./constants";

export const TeamContent = memo(({ activeTab, teamData, games, teamId, years, statData }) => {

  const battingColumns = useMemo(() => {
    const cols = getTeamBattingColumns();
    return cols.filter((c) => !["Team", "Conference", "Division"].includes(c.name));
  }, []);

  const pitchingColumns = useMemo(() => {
    const cols = getTeamPitchingColumns();
    return cols.filter((c) => !["Team", "Conference", "Division"].includes(c.name));
  }, []);

  if (activeTab === STAT_TYPES.ROSTER) {
    return <Roster teamId={teamId} years={years} />;
  }

  if (activeTab === STAT_TYPES.BATTING) {
    return (
      <div className="p-6">
        <BaseballTable
          title=""
          data={teamData?.batting_stats || []}
          columns={battingColumns}
          filename={`${teamData?.team_name}_batting.csv`}
          noDataComponent={
            <div className="text-center py-12 text-gray-500">
              No batting data available
            </div>
          }
        />
      </div>
    );
  }

  if (activeTab === STAT_TYPES.PITCHING) {
    return (
      <div className="p-6">
        <BaseballTable
          title=""
          data={teamData?.pitching_stats || []}
          columns={pitchingColumns}
          filename={`${teamData?.team_name}_pitching.csv`}
          noDataComponent={
            <div className="text-center py-12 text-gray-500">
              No pitching data available
            </div>
          }
        />
      </div>
    );
  }

  if (activeTab === STAT_TYPES.GAMES) {
    return <TeamGames games={games} teamName={teamData?.team_name} />;
  }

  if (activeTab === STAT_TYPES.LINEUP) {
    return <LineupUsage teamId={teamId} years={years} />;
  }

  if (activeTab === STAT_TYPES.BULLPEN) {
    return <PitcherUtilization teamId={teamId} years={years} />;
  }

  if (activeTab === STAT_TYPES.VALUE_BATTING) {
    return (
      <div className="p-6">
        <TeamStatTable
          stats={statData?.[STAT_TYPES.VALUE_BATTING] || []}
          type={STAT_TYPES.VALUE_BATTING}
          teamName={teamData?.team_name}
        />
      </div>
    );
  }

  if (activeTab === STAT_TYPES.VALUE_PITCHING) {
    return (
      <div className="p-6">
        <TeamStatTable
          stats={statData?.[STAT_TYPES.VALUE_PITCHING] || []}
          type={STAT_TYPES.VALUE_PITCHING}
          teamName={teamData?.team_name}
        />
      </div>
    );
  }

  if (activeTab === STAT_TYPES.SITUATIONAL_BATTING) {
    return (
      <div className="p-6">
        <TeamStatTable
          stats={statData?.[STAT_TYPES.SITUATIONAL_BATTING] || []}
          type={STAT_TYPES.SITUATIONAL_BATTING}
          teamName={teamData?.team_name}
        />
      </div>
    );
  }

  if (activeTab === STAT_TYPES.SITUATIONAL_PITCHING) {
    return (
      <div className="p-6">
        <TeamStatTable
          stats={statData?.[STAT_TYPES.SITUATIONAL_PITCHING] || []}
          type={STAT_TYPES.SITUATIONAL_PITCHING}
          teamName={teamData?.team_name}
        />
      </div>
    );
  }

  if (activeTab === STAT_TYPES.SPLITS_BATTING) {
    return (
      <div className="p-6">
        <TeamStatTable
          stats={statData?.[STAT_TYPES.SPLITS_BATTING] || []}
          type={STAT_TYPES.SPLITS_BATTING}
          teamName={teamData?.team_name}
        />
      </div>
    );
  }

  if (activeTab === STAT_TYPES.SPLITS_PITCHING) {
    return (
      <div className="p-6">
        <TeamStatTable
          stats={statData?.[STAT_TYPES.SPLITS_PITCHING] || []}
          type={STAT_TYPES.SPLITS_PITCHING}
          teamName={teamData?.team_name}
        />
      </div>
    );
  }

  if (activeTab === STAT_TYPES.BATTED_BALL_BATTING) {
    return (
      <div className="p-6">
        <TeamStatTable
          stats={statData?.[STAT_TYPES.BATTED_BALL_BATTING] || []}
          type={STAT_TYPES.BATTED_BALL_BATTING}
          teamName={teamData?.team_name}
        />
      </div>
    );
  }

  if (activeTab === STAT_TYPES.BATTED_BALL_PITCHING) {
    return (
      <div className="p-6">
        <TeamStatTable
          stats={statData?.[STAT_TYPES.BATTED_BALL_PITCHING] || []}
          type={STAT_TYPES.BATTED_BALL_PITCHING}
          teamName={teamData?.team_name}
        />
      </div>
    );
  }

  if (activeTab === STAT_TYPES.BASERUNNING) {
    return (
      <div className="p-6">
        <TeamStatTable
          stats={statData?.[STAT_TYPES.BASERUNNING] || []}
          type={STAT_TYPES.BASERUNNING}
          teamName={teamData?.team_name}
        />
      </div>
    );
  }

  return null;
});

TeamContent.displayName = "TeamContent";

